<template>
  <form @submit.prevent="handleSubmit">
    <b-field label="Name">
      <b-input v-model="form.name"></b-input>
    </b-field>

    <b-field label="Link" message="Deep or outgoing link.">
      <b-input v-model="form.link"></b-input>
    </b-field>

    <div class="columns">
      <div class="column">
        <b-field label="Start Date">
          <datetimepicker v-model="form.starts_at"></datetimepicker>
        </b-field>
      </div>

      <div class="column">
        <b-field label="End Date">
          <datetimepicker v-model="form.ends_at"></datetimepicker>
        </b-field>
      </div>
    </div>

    <b-field>
      <b-checkbox v-model="form.is_active">Is Active?</b-checkbox>
    </b-field>

    <button
      class="button is-primary"
      style="margin-bottom: 1rem;"
      :class="{ 'is-loading': form.processing }"
    >Update Banner</button>

    <b-field label="Mobile">
      <upload-banner-image
        :src="banner.media.sm"
        :banner-id="banner.id"
        size="sm"
        style="min-height: 100px;"
      ></upload-banner-image>
    </b-field>

    <b-field label="Tablet">
      <upload-banner-image
        :src="banner.media.md"
        :banner-id="banner.id"
        size="md"
        style="min-height: 100px;"
      ></upload-banner-image>
    </b-field>
  </form>
</template>

<script>
import UploadBannerImage from "@/modules/admin/pages/marketing/UploadBannerImage";

export default {
  components: {
    UploadBannerImage
  },

  props: {
    banner: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: null
    };
  },

  created() {
    this.initialize();
  },

  watch: {
    banner() {
      this.initialize();
    }
  },

  methods: {
    initialize() {
      this.form = new window.Form({
        name: this.banner.name,
        link: this.banner.deep_link,
        is_active: this.banner.is_active,
        starts_at: this.banner.starts_at,
        ends_at: this.banner.ends_at
      });
    },

    uri() {
      return "/admin/api/marketing/banners/" + this.banner.id;
    },

    handleSubmit() {
      this.form.put(this.uri()).then(res => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully saved."
        });

        this.$emit("updated", res.data);
      });
    }
  }
};
</script>
